// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --dark-grey: rgb(64, 64, 64);
  --dark-grey-transparent: rgba(64, 64, 64, 0.5);
  --medium-grey: rgb(128, 128, 128);
  --light-grey: rgb(192, 192, 192);
  --extra-light-grey: rgb(232, 232, 232);
  --input-background-color: white;
  --input-highlight-background-color: #05326e;
  --selection-background-color: rgba(5, 50, 110, 0.8);
  --selection-hover-color: rgba(5, 50, 110, 0.9);
  --item-hover-color: rgba(5, 50, 110, 0.2);
  --overlay-panel-background-color: #05326e;
  --border-color: rgb(128, 128, 128);
  --border-color-transparent: rgb(128, 128, 128);
  --text-color: black;
  --text-color-inactive: var(--medium-grey);
  --text-color-disabled: var(--light-grey);
  --text-contrast-color: rgb(255, 255, 255);
  --dialog-background-color: white;
  --dark-blue-background-color: rgba(5, 50, 110, 0.75);
  --blue-background-color: rgba(5, 50, 110, 0.5);
  --light-blue-background-color: #c0ccdb;
  --extra-light-blue-background-color: #dae3ec;
  --error-color: red;
  --warn-color: #ff5a00;
  --success-color: #00b23e;
  --info-color: #05326e;
  --light-blue: #5bb5e5;
  --input-accent-color: #05326e;
  --drop-target-overlay-color: #05326e;
}

.warn-color {
  color: var(--warn-color);
}

.success-color {
  color: var(--success-color);
}

.info-color {
  color: var(--info-color);
}

.error-color {
  color: var(--error-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/variables/colors.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,iCAAiC;EACjC,gCAAgC;EAChC,sCAAsC;EACtC,+BAA+B;EAC/B,2CAA2C;EAC3C,mDAAmD;EACnD,8CAA8C;EAC9C,yCAAyC;EACzC,yCAAyC;EACzC,kCAAkC;EAClC,8CAA8C;EAC9C,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;EACzC,gCAAgC;EAChC,oDAAoD;EACpD,8CAA8C;EAC9C,sCAAsC;EACtC,4CAA4C;EAC5C,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[":root {\n  --dark-grey: rgb(64, 64, 64);\n  --dark-grey-transparent: rgba(64, 64, 64, 0.5);\n  --medium-grey: rgb(128, 128, 128);\n  --light-grey: rgb(192, 192, 192);\n  --extra-light-grey: rgb(232, 232, 232);\n  --input-background-color: white;\n  --input-highlight-background-color: #05326e;\n  --selection-background-color: rgba(5, 50, 110, 0.8);\n  --selection-hover-color: rgba(5, 50, 110, 0.9);\n  --item-hover-color: rgba(5, 50, 110, 0.2);\n  --overlay-panel-background-color: #05326e;\n  --border-color: rgb(128, 128, 128);\n  --border-color-transparent: rgb(128, 128, 128);\n  --text-color: black;\n  --text-color-inactive: var(--medium-grey);\n  --text-color-disabled: var(--light-grey);\n  --text-contrast-color: rgb(255, 255, 255);\n  --dialog-background-color: white;\n  --dark-blue-background-color: rgba(5, 50, 110, 0.75);\n  --blue-background-color: rgba(5, 50, 110, 0.5);\n  --light-blue-background-color: #c0ccdb;\n  --extra-light-blue-background-color: #dae3ec;\n  --error-color: red;\n  --warn-color: #ff5a00;\n  --success-color: #00b23e;\n  --info-color: #05326e;\n  --light-blue: #5bb5e5;\n  --input-accent-color: #05326e;\n  --drop-target-overlay-color: #05326e;\n}\n\n.warn-color {\n  color: var(--warn-color);\n}\n\n.success-color {\n  color: var(--success-color);\n}\n\n.info-color {\n  color: var(--info-color);\n}\n\n.error-color {\n  color: var(--error-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
